import Transitions from "../__utils/elementsTransition";

const $ = jQuery.noConflict();

class AjaxFilters {
    constructor() {
        this.trigger = $('.letters-filter');
    }
    init() {
        this.bindEvents();
    }
    bindEvents() {
        this.trigger.on('click', this.ajaxPosts);
    }
    ajaxPosts(e) {
        const postsWrapper = $('.letters-loop .container .row');
        const paginationWrapper = $('.pagination--letters');
        const trigger = $(this);
        const category = trigger.data('letter') === 'all' ? false : trigger.data('letter');
        const historyState = trigger.attr('href');
        e.preventDefault();
        $.ajax({
            url: WP.ajaxUrl,
            type: 'POST',
            data: {
                action: 'ajaxFilter',
                category,
            },
            success: (results) => {
                paginationWrapper.remove();
                $('.letters-filter').removeClass('active');
                trigger.addClass('active');
                console.log(results);
                postsWrapper.html(results);
                AjaxFilters.ajaxPagination(category, historyState);
                window.history.pushState({}, historyState, historyState);
                Transitions.makeElTransition();
            },
        });
    }
    static ajaxPagination(category, url) {
        const postsWrapper = $('.letters-loop');
        $.ajax({
            url: WP.ajaxUrl,
            type: 'POST',
            data: {
                action: 'ajaxPagination',
                category,
                url,
            },
            success: (results) => {
                $(results).insertAfter(postsWrapper);
            },
        });
    }
}

export default new AjaxFilters();
